import React, { Suspense, useContext } from 'react';

import salesTypes from 'maps/sales-types';
import { EntityContext } from 'context/entityContext';

import StreamingKPIs from 'components/data-containers/KPIs/Streaming/StreamingKPIs';
import PerformanceTrendSkeletonLoader from 'components/data-containers/PerformanceTrend/SkeletonLoader';
import PerformanceBreakdownLoader from 'components/data-containers/PerformanceBreakdown/SkeletonLoader';

const StreamingPerformanceTrend = React.lazy(() =>
  import(
    'components/data-containers/PerformanceTrend/PerformanceComponent/PerformanceComponent'
  )
);

const SourceOfStreams = React.lazy(() =>
  import('components/data-containers/PerformanceTrend/SourceOfStreams')
);

const PerformanceBreakdown = React.lazy(() =>
  import(
    'components/data-containers/AccessTypePerformanceBreakdown/PerformanceBreakdown'
  )
);

const Streaming: React.FC = () => {
  const { compareMode } = useContext(EntityContext);

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <StreamingKPIs
        allowedFilters={[
          'country',
          'streaming',
          'media',
          'region',
          'customRegion',
        ]}
        glossarySlug="kpis/streaming-kpis"
      />

      <Suspense
        fallback={
          <PerformanceTrendSkeletonLoader
            title="Streaming Performance"
            dropdownLabel="All DSPs"
            toggleOptions={[
              { value: 'aggregate', label: 'All DSPs', active: true },
              { value: 'all', label: 'By DSP', active: false },
            ]}
            showPeriodDropdown
            isWide
          />
        }
      >
        <StreamingPerformanceTrend
          componentId="streaming-performance-trend"
          salesType={salesTypes.streaming}
          title="Streaming Performance"
          accessBreakdown={true}
          withCustomRange
        />
      </Suspense>

      <Suspense
        fallback={
          <PerformanceTrendSkeletonLoader
            title="Source of Streams"
            dropdownLabel={compareMode && 'Playlist'}
            showPeriodDropdown
            isWide
          />
        }
      >
        <SourceOfStreams salesType={salesTypes.streaming} />
      </Suspense>
      <Suspense
        fallback={
          <PerformanceBreakdownLoader
            barCount={6}
            title={'Total Release To Date'}
            isWide
          />
        }
      >
        <PerformanceBreakdown salesType={salesTypes.streaming} hasDSPSelector />
      </Suspense>
    </div>
  );
};

export default Streaming;
